import { render, staticRenderFns } from "./course_asynclist.vue?vue&type=template&id=516dca9a&scoped=true"
import script from "./course_asynclist.vue?vue&type=script&lang=js"
export * from "./course_asynclist.vue?vue&type=script&lang=js"
import style0 from "./course_asynclist.vue?vue&type=style&index=0&id=516dca9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516dca9a",
  null
  
)

export default component.exports